<script setup>
import {reactive,onMounted,ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextIdA: String,
  contextIdB: String
});

const form = ref(null);

const data = reactive({
  valid: true,
  isDisabled: false,
  loading: false,
  dataLoading: true,
  search: null,
  newAdj: false,
  headers: [
    { title: 'Date', key: 'date' },
    { title: 'Amount', key: 'amount' },
    { title: 'Description', key: 'description' },
  ],
  items: [],
  newItem: {
    amount: null,
    description: null,
  },
});

const getData = () => {
  data.isDisabled = false;
  let contextIdA = props.contextIdA;
  let contextIdB = props.contextIdB;
  // No contextIdB (personId) provided, look at logged in user
  if (!contextIdB) {
    ApiWrapper.post('adjustments', 'my-pay-period', {payPeriodId: contextIdA})
        .then((response) => {
          if(response){
            if(response.adjustments){
              data.items = response.adjustments
            }
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false
        });
  } else {
    ApiWrapper.get(
            'adjustments',
            'pay-period-person','payPeriodId=' +
            contextIdA +
            '&personId=' +
            contextIdB
        )
        .then((response) => {
          data.items = response.adjustments;
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false
        });
  }
}

const saveItem = () => {
  if (form.value.validate()) {
    data.isDisabled = true;
    data.loading = true;

    let contextIdA = props.contextIdA;
    let contextIdB = props.contextIdB;

    ApiWrapper.post('adjustments', 'create', {
          newAdjustment: data.newItem,
          payPeriodId: contextIdA,
          personId: contextIdB
        })
        .then((response) => {
          getData();
          discardItem();

          ToastUtil.successMsg('Created adjustment');
        })
        .catch((err) => {
          ToastUtil.error(err);
        })
        .finally(() => {
          data.loading = false
        });
  }
}

const discardItem = () => {
  data.newItem.amount = null
  data.newItem.description = null
  data.newAdj = false
}

onMounted(()=>{
  getData()
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Adjustments</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        ></v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>

        <v-spacer></v-spacer>


      </v-toolbar>

      <v-form
          ref="form"
          v-model="data.valid"
          lazy-validation
          v-if="data.newAdj"
      >
        <v-row class="px-5">
          <v-col cols="12" sm="3">
            <v-text-field
                type="number"
                v-model="data.newItem.amount"
                label="Amount"
                :rules="[v => !!v || 'Amount is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="5">
            <v-text-field
                v-model="data.newItem.description"
                label="Description"
                :rules="[v => !!v || 'Description is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-btn size="small" variant="elevated" class="px-2" @click="saveItem" color="primary" :disabled="!data.valid || data.isDisabled === true">
              <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
            <v-btn size="small" variant="elevated" class="px-2" @click="discardItem" color="error">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-text-field
            v-model="data.search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            class="px-10"
        ></v-text-field>
      </v-row>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          :search="data.search"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      ></v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
</style>